import axios from 'axios';

const getBaseURL = () => {
  const hostname = window.location.hostname;

  // Detect Capacitor mobile app
  const isMobileApp =
    window.location.protocol === 'capacitor:' ||
    (window.Capacitor !== undefined);

  console.log(isMobileApp, "isMobileApp");

  // MOBILE APP
  if (isMobileApp) {
    return process.env.REACT_APP_MOBILE_API_URL || 'https://api.the-society.vistaran.com';
  }

  // WEB LOCAL DEVELOPMENT
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:8000';
  }

  // WEB TENANT DOMAIN
  return process.env.REACT_APP_API_URL || 'https://api.the-society.vistaran.com';
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const tenantId = localStorage.getItem('tenant_id');
    const tenantSlug = localStorage.getItem('tenant_slug');

    if (tenantId) {
      config.headers['X-Tenant-ID'] = tenantId;
    }

    if (tenantSlug) {
      config.headers['X-Tenant-Slug'] = tenantSlug;
    }

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    let userMessage = null;
    if (data?.errors && typeof data.errors === 'object') {
      const fieldErrors = Object.values(data.errors).flat().filter(Boolean);
      if (fieldErrors.length > 0) {
        userMessage = fieldErrors.join('; ');
      }
    }
    if (!userMessage) {
      userMessage = data?.error || data?.message || error.message || 'An unexpected error occurred';
    }

    const apiError = {
      status,
      message: userMessage,
      error: data?.error || null,
      errors: data?.errors || null,
      data: data,
      response: error.response,
      success: false,
    };

    if (status === 401 || (status === 404 && data?.message === 'Invalid Tenant ID provided in headers.')) {
      window.dispatchEvent(new CustomEvent('auth-expired'));
      // Prevent throwing this specific error further down to avoid unnecessary toasts during logout
      if (status === 404) {
        return new Promise(() => { }); // Never resolves, effectively silencing the error chain
      }
    }

    return Promise.reject(apiError);
  }
);

export default axiosInstance;